import {LatLngTuple} from "leaflet"
import {NonFunctionProperties} from "../types";

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
}

export default class Room {

  constructor(room: NonFunctionProperties<Room>) {
    Object.assign(this, room)
  }

  /** e.g. "A0.10" */
  ID: string = "";
  Geo_Koordinaten: LatLngTuple | null = null
  /** e.g. "Seminarraum" */
  Typ: string = ""
  /** e.g. "SR03" */
  AID: string = ""
  /** e.g. "Agnesi" */
  Bezeichnung?: string
  Name?: string
  Größe_m2: string = ""
  alte_Bezeichnung: string | null = null
  Mitarbeiterkürzel?: string;

  // aus krg/mitarbeiterprofile.csv, über das Mitarbeiterkürzel
  description?: string;
  link?: string;
  imageUrl?: string;

  /** Raumbezeichnung, bei Seminarräumen mit SR-Nummer */
  get title(): string {
    if (this.Typ === 'Seminarraum') {
        const match = this.AID.slice(-2)
        const number = parseInt(match)
        return `SR ${number} - ${this.Bezeichnung}`
    }

    return this.Bezeichnung ?? ""
  }

  // used by react-select
  get label(): string {
    const parts = [
      this.title,
    ]

    if (this.Name) {
      parts.push(`— ${this.Name}`)
    }

    return parts.join(" ")
  }

  // used by react-select
  get value(): string {
    return this.ID
  }

  /**
   * @return "A", "B", "C", "D, "E", "F" or "G"
   */
  buildingKey(): string {
    return this.ID[0]
  }

  /**
   * @returns "0", "1", "2" or "U"
   */
  level(): string {
    return this.ID[1]
  }

  levelFormatted(): string {
    const l = this.level()

    if (l == "U") {
      return "Untergeschoss"
    } else if (l == "0") {
      return "Ebene 0"
    } else {
      return `${l}. Obergeschoss`
    }
  }

  popupHTML(): string {
    return `<div class="popup-container">
      <div class="popup-header">
        <span class="popup-room">${escapeHtml(this.ID)} — ${this.levelFormatted()}</span>
        <h3 class="popup-title">${escapeHtml(this.title)}</h3>
      </div>
      ${this.personHTML()}
    </div>`;
  }

  private personHTML(): string {
    if (!this.Name && !this.Mitarbeiterkürzel) {
      return ''
    }

    return `<div class="popup-person">
      ${this.imageUrl ? `<img class="popup-avatar" src="${escapeHtml(this.imageUrl)}" alt="" onerror="this.remove()">` : ''}
      <div class="popup-person-text">
        <div class="popup-person-head">
          ${this.Name ? `<span class="popup-name">${escapeHtml(this.Name)}</span>` : ''}
          ${this.Mitarbeiterkürzel ? `<span class="popup-kuerzel">${escapeHtml(this.Mitarbeiterkürzel)}</span>` : ''}
        </div>
        ${this.description ? `<p class="popup-description">${escapeHtml(this.description)}</p>` : ''}
        ${this.link ? `<a class="popup-link" href="${escapeHtml(this.link)}" target="_blank" rel="noopener">Zum Profil</a>` : ''}
      </div>
    </div>`;
  }

}
